export default __webpack_public_path__ + "static/StrategyUI-b573cd857f8068cb21455091415f0244.png";